import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  /* Main Select Container */
  .ant-select-selector {
    border-radius: 12px !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px) !important;
    transition: all 0.3s ease !important;
    min-height: 40px !important;
    // height: 100% !important;
    padding: 8px 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  }

  .ant-select-selector:hover {
    border-color: #e36e00 !important;
    box-shadow: 0 4px 12px rgba(227, 110, 0, 0.15) !important;
    transform: translateY(-1px) !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: #e36e00 !important;
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1) !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(55, 65, 81, 0.6) !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .ant-select-selection-item {
    color: #374151 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  .ant-select-arrow {
    color: #e36e00 !important;
    transition: all 0.2s ease !important;
    font-size: 12px !important;
  }

  .ant-select:hover .ant-select-arrow {
    transform: scale(1.1) !important;
  }

  /* Dropdown Menu */
  .ant-select-dropdown {
    z-index: 999999 !important;
    padding: 8px 0 !important;
    border-radius: 12px !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(20px) !important;
  }

  /* Dropdown Items */
  .ant-select-item {
    padding: 10px 16px !important;
    margin: 2px 8px !important;
    border-radius: 8px !important;
    transition: all 0.2s ease !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #374151 !important;
    border: none !important;
  }

  .ant-select-item:hover {
    background: linear-gradient(
      135deg,
      rgba(227, 110, 0, 0.08) 0%,
      rgba(255, 174, 0, 0.08) 100%
    ) !important;
    color: #e36e00 !important;
  }

  /* allow item text to wrap or show ellipsis instead of clipping */
  .ant-select-item-option-content {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .ant-select-item-option-selected {
    background: linear-gradient(
      135deg,
      rgba(227, 110, 0, 0.12) 0%,
      rgba(255, 174, 0, 0.12) 100%
    ) !important;
    color: #e36e00 !important;
    font-weight: 600 !important;
  }

  .ant-select-item-option-active {
    background: linear-gradient(
      135deg,
      rgba(227, 110, 0, 0.15) 0%,
      rgba(255, 174, 0, 0.15) 100%
    ) !important;
    color: #e36e00 !important;
  }

  /* Clear Button */
  .ant-select-clear {
    background: rgba(227, 110, 0, 0.1) !important;
    color: #e36e00 !important;
    border-radius: 50% !important;
    transition: all 0.2s ease !important;
  }

  .ant-select-clear:hover {
    background: rgba(227, 110, 0, 0.2) !important;
    transform: scale(1.1) !important;
  }
`;

const ChildContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
  ChildContainer,
};

export default SC;
